import React, { Fragment } from 'react'
import { components } from 'react-select'

const { ValueContainer, Placeholder } = components

export default function CustomValueContainer({ children, ...props }) {
  // Function to render the placeholder using dangerouslySetInnerHTML
  const renderPlaceholder = (placeholderText) => {
    return {
      __html: placeholderText
    }
  }

  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {(props.hasValue || props.selectProps.menuIsOpen) ? (
          <div dangerouslySetInnerHTML={renderPlaceholder(props.selectProps ? props.selectProps.placeholder : '')} style={{ fontWeight: '500' }} />
        ) : (
          <div dangerouslySetInnerHTML={renderPlaceholder(props.selectProps ? props.selectProps.placeholder : '')} />
        )}
      </Placeholder>
      {React.Children.map(children, (child) => {
        return (
          <Fragment>{child && child.key !== "placeholder" ? child : null}</Fragment>
        )
      })}
    </ValueContainer>
  )
}